import { ReactNode, useEffect } from 'react';

import { ThemeContext, type ThemeContextType } from '@/providers/themeContext';

const themeValue: ThemeContextType = {
  theme: 'light',
  setTheme: () => {},
  resolvedTheme: 'light',
};

export function ThemeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
    root.classList.add('light');
    root.style.colorScheme = 'light';
  }, []);

  return <ThemeContext.Provider value={themeValue}>{children}</ThemeContext.Provider>;
}
